module.exports = "#content {\n  background: #ffffff; }\n"